module.exports = __webpack_public_path__ + "img/3.29e98a28.svg";